export default __webpack_public_path__ + "static/media/office1-after2-1920w.8a9a895e.webp";